export const apiUrl = {
  FAZX_SEVICEURL: `http://fasuzaixianapi.yiwangtui.com/`, // 法速在线
}